(function ($) {
	"use strict";

	$(window).scroll(function () {
		VegasListener.onScroll($(this));
	});

	$(window).resize(function () {
		VegasListener.onResize($(this));
	});

	$(document).ready(function () {
		VegasListener.onReady();
		VegasListener.onClick();
	});

	$(document).ready(function () {

		var menuAnitate = false;

		$(document).on('mouseover', '.categories-container li', function () {
			let menu = $(this).find('.children-wrapper');
			if (menu.length) {
				if (!menu.hasClass('active') && !menuAnitate) {
					menuAnitate = true;
					menu.show();
					menu.animate({
						'opacity': 1,
						'margin-top': 0
					}, 250, function () {
						menuAnitate = false;
						menu.addClass('active');
					});
				}
			}
		});
		$(document).on('mouseleave', '.categories-container li', function (e) {
			let menu = $(this).find('.children-wrapper');
			if (menu.length && menu.hasClass('active')) {
				menu.animate({
					'opacity': 0,
					'margin-top': '-50px'
				}, 250, function () {
					menu.removeClass('active');
					menu.hide();
				});
			}
		});
		$('.menu-item-name').on('click', function () {
			let subMenu = $(this).closest('.menu-item').find('.menu-children-inner');
			let url = $(this).attr('data-url');
			if (subMenu.length) {
				$('.vg-nav-sidebar--header .titles').html('<i class="fa fa-triangle"></i><a href="' + url + '">' + $(this).text() + '</a>');
				subMenu.show();
				subMenu.animate({
					'left': 0
				}, 250);
			} else {
				location.href = url;
			}
		});
		$(document).on('click', '.vg-nav-sidebar--header .titles i', function () {
			$('.vg-nav-sidebar--header .titles').html('Florseason');

			$('.menu-children-inner').animate({
				'left': '100%'
			}, 250, function () {
				$('.menu-children-inner').hide();
			});
		});

		$('.children-main-title').on('click', function () {
			let subMenu = $(this).closest('.menu-children-main');
			if (subMenu.length && !subMenu.hasClass('active')) {
				subMenu.addClass('active');
				let height = subMenu.find('.child-item').outerHeight() * subMenu.find('.child-item').length;
				subMenu.find('.sub-childs-wrapper').animate({
					'height': height + 'px'
				}, 250);
			} else {
				subMenu.find('.sub-childs-wrapper').animate({
					'height': 0
				}, 250, function () {
					subMenu.removeClass('active');
				});
			}
		});

	});


	// [vegas]
	Vegas.log();

	let hoverMatched = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
	$('.prd-grid')
		.mouseenter(function () {
			if (hoverMatched) {
				$(this).find('.prd-params').addClass('show');
			}
		})
		.mouseleave(function () {
			if (hoverMatched) {
				$(this).find('.prd-params').removeClass('show');
			}
		})
		.click(function () {
			let $params = $(this).find('.prd-params');
			if ($params.length && !$params.hasClass('show')) {
				$params.addClass('show');
				return false;
			}
		})
		.blur(function() {
			$(this).find('.prd-params').removeClass('show');
		})
	;

})(jQuery);
